module.exports = __webpack_public_path__ + "static/media/netacad_logo_black.fc2511d7.svg";